<template>
  <div class="row product-details">
    <div class="product-card col-lg-5 col-md-6 col-sm-12">
      <div class="prod-image product_image_width">
        <!-- Show loading state if product is not yet loaded -->
        <div v-if="loading" class="text-center py-4">
          <p>Loading product...</p>
        </div>
        <template v-else>
          <Carousel
            ref="carousel"
            v-if="product && product.imagesDetails && product.imagesDetails.length > 1"
            v-bind="config"
            @slide-change="onSlideChange"
          >
            <Slide v-for="(img, index) in product.imagesDetails" :key="index">
              <img :src="img.path" class="prod-img big-image" @click="selectImage(img)" />
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
          <img v-else :src="selectedImage || ProductImgDefault" class="prod-img big-image" />
          <!-- Miniatures -->
          <div
            v-if="product && product.imagesDetails && product.imagesDetails.length > 1"
            class="flex text-center pt-4"
          >
            <img
              v-for="(image, index) in product.imagesDetails.slice(0, 4)"
              :key="index"
              :src="image.path"
              class="thumbnail w-20 h-20 object-cover border-2 rounded transition duration-300 hover:opacity-80"
              @click="selectImage(image)"
            />
          </div>
        </template>
      </div>
    </div>
    <div class="product-info col-lg-6 col-md-6 col-sm-12 mx-2 py-0 d-flex justify-content-start">
      <label class="gamme">{{ product.gamme_supplyvet ?? "" }}</label>
      <label class="title">{{ product.name }}</label>
      <!-- <label v-if="product?.variant?.ref" class="reference mt-1">REF : {{ product.variant.ref ?? "" }}</label> -->
      <hr />

      <div class="desc row">
        <p v-html="$sanitize.sanitizeProductInfo(product.description)"></p>
        <div class="price-unites row my-3" v-if="generateTieredPrices().length > 1">
          <span class="mb-2" v-for="(tier, index) in generateTieredPrices()" :key="index">
            {{ tier.label }} = {{ tier.price }} {{ isClient ? "€ TTC" : "€ HT" }}
          </span>
        </div>
        <div>
          <span v-if="product?.variant?.currentChannelPricings" class="price my-auto col col-lg-4 px-0 mx-0">
            {{ formatPrice(isClient ? product.variant.price_ttc : product.variant.price_ht) }}
            <span>{{ isClient ? "€ TTC" : "€ HT" }}</span>
          </span>
          <span
            v-if="product.variant.price_original_ht > product.variant.price_ht && !isClient"
            class="old-price my-auto col col-lg-4 px-0 mx-4"
          >
            <label>{{ formatPrice(product.variant.price_original_ht) }} € HT</label>
          </span>
          <span
            v-if="product.variant.price_original_ttc > product.variant.price_ttc && isClient"
            class="old-price my-auto col col-lg-4 px-0 mx-4"
          >
            <label>{{ formatPrice(product.variant.price_original_ttc) }} € TTC</label>
          </span>
        </div>
        <div class="inline-block my-3 px-0">
          <label
            v-for="variant in product?.variantsDetails?.filter(v => v.unity === 'u' && v.enabled !== false) || []"
            class="round mx-2 px-4 py-1 my-2"
            :class="{ active: variant.name === product?.variant?.name }"
            :key="variant.id"
            @click.prevent="ChangeVariant(variant)"
          >
            {{ variant.poidsNet }}
            <img v-if="variant.name == product.variant.name" :src="iconchecked" />
          </label>
        </div>
        <div class="d-flex check-disponibility align-items-end my-3">
          <template
            v-if="
              product?.variant?.datePrecommandeSupplyvetEsupplyvet &&
              new Date(product.variant.datePrecommandeSupplyvetEsupplyvet) > new Date()
            "
          >
            <label class="mr-2 d-flex align-items-center">Précommande : </label>
            <span
              >Livraison à partir du
              {{ new Date(product.variant.datePrecommandeSupplyvetEsupplyvet).toLocaleDateString("fr-FR") }}</span
            >
          </template>
          <template v-else-if="product?.variant?.inStock">
            <label class="mr-2 d-flex align-items-center">En stock : </label>
            <span>Livraison sous 48h à 72h</span>
          </template>
          <template v-else>
            <label class="mr-2">Disponible en pré-commande: </label>
            <span>Livraison sous 2 semaines</span>
          </template>
        </div>

        <div class="d-flex block-btn-cart">
          <template v-if="product?.variant?.inStock && !product?.variant?.datePrecommandeSupplyvetEsupplyvet">
            <div class="input-wrapper">
              <div class="btn-minus" @click.prevent="Decrement()">-</div>
              <input type="text" class="number-input" v-model="qte" disabled />
              <div class="btn-plus" @click.prevent="Increment()">+</div>
            </div>
            <button class="btn text-white add-cart py-0" @click.prevent="AddProductToCart">
              Ajouter au panier <span class="spinner-circle-small white ms-2" v-if="loadingAddProduct"></span>
            </button>
          </template>
          <button v-else class="btn text-white pre-commande w-50 py-0" @click="AddProductToCart">
            Pré-commander <span class="spinner-circle-small white ms-2" v-if="loadingAddProduct"></span>
          </button>
          <div v-if="!product?.has_favorite" class="favorite-wrapper mx-2" @click.prevent="ToggleFavorite(product)">
            <img :src="iconfav" /><span class="mx-2">Ajouter à mes favoris</span>
          </div>
          <div v-else class="favorite-wrapper mx-2" @click.prevent="ToggleFavorite(product)">
            <img :src="iconfav" /><span class="mx-2">Supprimer de favoris</span>
          </div>
        </div>
      </div>
    </div>
    <div class="product-info-detailed col-lg-12 col-md-12 col-sm-12 my-4">
      <div class="tabs">
        <div
          class="tab first-tab"
          :class="{ active: activeTab === 'composition' }"
          @click="setActiveTab('composition')"
        >
          Composition
        </div>
        <div
          class="tab second-tab"
          :class="{ active: activeTab === 'mode-emploi' }"
          @click="setActiveTab('mode-emploi')"
        >
          Mode d'emploi
        </div>
      </div>
      <div class="tab-container">
        <div class="tab-content-container">
          <div v-show="activeTab === 'composition'" class="tab-content">
            <div
              v-if="product?.compositionHeader"
              v-html="transformSectionTitles(product.compositionHeader)"
              class="composition-header mb-3"
            ></div>
            <div
              v-if="product?.nutritionalGoal"
              v-html="transformSectionTitles(product.nutritionalGoal)"
              class="composition-text mb-3"
            ></div>
            <div
              v-if="product?.ingredientsSpecifiques || product?.ingredients_specifiques"
              class="composition-text mb-3"
            >
              <div
                v-if="!hasIngredientsTitle(product?.ingredientsSpecifiques || product?.ingredients_specifiques)"
                class="section-title-blue mb-1"
              >
                <b>INGRÉDIENTS SPÉCIFIQUES :</b>
              </div>
              <div
                class="ingredients-content"
                v-html="
                  $sanitize.sanitizeProductInfo(product.ingredientsSpecifiques || product.ingredients_specifiques)
                "
              ></div>
            </div>
            <div
              v-if="product?.composition"
              v-html="transformSectionTitles(product.composition)"
              class="composition-text mb-3"
            ></div>
            <div
              v-if="getConstituantsAnalytiques().label || getConstituantsAnalytiques().rows.length"
              class="constituants-section w-50"
            >
              <b v-if="getConstituantsAnalytiques().label">{{ getConstituantsAnalytiques().label }}</b>
              <table
                v-if="getConstituantsAnalytiques().rows.length"
                class="table table-striped table-bordered table-sm constituants-table mt-2"
              >
                <thead class="table-primary"></thead>
                <tbody>
                  <tr v-for="(item, index) in getConstituantsAnalytiques().rows" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              v-if="
                getAdditivesData().type === 'structured' &&
                (getAdditivesData().label || getAdditivesData().sections.length)
              "
              class="additives-section w-50"
            >
              <b v-if="getAdditivesData().label">{{ getAdditivesData().label }}</b>
              <div
                v-for="(section, sectionIndex) in getAdditivesData().sections"
                :key="sectionIndex"
                class="additive-subsection mt-2"
              >
                <div v-if="section.label" class="additive-sub-label">
                  <p class="mb-2">{{ section.label }}</p>
                </div>
                <table
                  v-if="section.rows.length"
                  class="table table-striped table-bordered table-sm constituants-table"
                >
                  <thead class="table-primary"></thead>
                  <tbody>
                    <tr v-for="(item, index) in section.rows" :key="index">
                      <td>{{ item.name }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else-if="getAdditivesData().type === 'simple'" class="additives-section">
              <div
                v-if="product?.additives"
                v-html="transformSectionTitles(product.additives)"
                class="additives-section"
              ></div>
            </div>
          </div>
          <div v-show="activeTab === 'mode-emploi'" class="tab-content">
            <div
              v-if="product?.instructionsForUse"
              v-html="transformSectionTitles(product.instructionsForUse)"
              class="instructions"
            ></div>
            <br />
            <div
              v-if="product?.precautionsForUse"
              v-html="transformSectionTitles(product.precautionsForUse)"
              class="precautions"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Bootstrap -->
  <div class="modal fade" tabindex="-1" ref="modalRef">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="header-modal text-end cursor-pointer">
          <img :src="iconclose" class="icon-close mx-3 my-3" @click.prevent="CloseModalCart" />
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2 col-md-2 d-mobile-hidden col-sm-2"></div>
            <div class="cart-product-card col-lg-3 col-md-3 col-sm-3">
              <div class="cart-product-image">
                <img :src="selectedImage || ProductImgDefault" class="prod-img" />
              </div>
            </div>
            <div class="cart-product-info col-lg-6 col-md-6 col-sm-6">
              <label class="gamme mb-2">{{ product?.gamme ?? "Croquette médicalisées" }}</label>
              <label class="title mb-1">{{ product?.name }}</label>
              <!-- <label class="reference mb-1">REF : {{ product?.variant?.ref }}</label> -->
              <div class="desc row w-100">
                <p v-html="$sanitize.sanitizeProductInfo(product.description)"></p>
                <div>
                  <span v-if="product?.variant?.currentChannelPricings" class="price my-auto col col-lg-4 px-0 mx-0">
                    {{ formatPrice(isClient ? product.variant.price_ttc : product.variant.price_ht) }}
                    <span>{{ isClient ? "€ TTC" : "€ HT" }}</span>
                  </span>
                  <span
                    v-if="product.variant.price_original_ht > product.variant.price_ht && !isClient"
                    class="old-price my-auto col col-lg-4 px-0 mx-4"
                  >
                    <label>{{ formatPrice(product.variant.price_original_ht) }} € HT</label>
                  </span>
                  <span
                    v-if="product.variant.price_original_ttc > product.variant.price_ttc && isClient"
                    class="old-price my-auto col col-lg-4 px-0 mx-4"
                  >
                    <label>{{ formatPrice(product.variant.price_original_ttc) }} € TTC</label>
                  </span>
                </div>
              </div>
              <label class="btn btn-qt my-1 w-35">Quantité : {{ qte }} {{ qte == 1 ? "produit" : "produits" }}</label>
            </div>
            <div class="col-lg-1 col-md-1 d-mobile-hidden col-sm-1"></div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 d-mobile-hidden"></div>
            <div class="col-lg-9 col-md-9 col-sm-9 d-flex my-4 justify-content-center">
              <button class="btn btn-shopping w-30 mx-3" @click.prevent="GoShopping">Continuer mes achats</button>
              <button class="btn text-white btn-checkout w-30" @click.prevent="FinishCheckout">
                Finaliser ma commande
              </button>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 d-mobile-hidden"></div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 d-mobile-hidden"></div>
            <div class="col-lg-9 col-md-9 col-sm-9 my-4">
              <label class="title-blue">Ces produits pourraient également vous intéresser</label>
            </div>
          </div>
          <div class="row">
            <div class="related-products col-lg-12 col-md-12 col-sm-12">
              <div class="row gap-mobile justify-content-mobile">
                <div class="col-lg-2 col-md-2 col-sm-2 my-4 d-mobile-hidden"></div>
                <template v-for="(prod, index) in related_products" :key="index">
                  <div class="col-lg-5 col-md-5 col-sm-5 my-4">
                    <div class="row">
                      <div class="related-product-card col-lg-4 col-md-4 col-sm-12 px-0">
                        <div class="related-product-image">
                          <img
                            :src="prod.images?.length > 0 ? prod.images[0].path : ProductImgDefault"
                            class="prod-img"
                          />
                        </div>
                      </div>
                      <div class="related-product-info col-lg-6 col-md-6 col-sm-12 mx-2">
                        <h4 class="title">{{ prod.name }}</h4>
                        <label v-if="prod.variant" class="sub-title d-block">{{ prod.variant.name }}</label>
                        <span v-if="prod?.variant?.currentChannelPricings" class="price my-auto">
                          {{ isClient ? prod.variant.price_ttc / 100 : prod.variant.price_ht / 100 }}
                          <span>{{ isClient ? '€ TTC' : '€ HT'}}</span>
                        </span>
                        <label class="prod-caract mx-3 px-2">20ml</label>
                        <button
                          class="btn text-white btn-add-cart mt-3 w-100"
                          @click.prevent="AddRelatedProductToCart(prod)"
                        >
                          Ajouter au panier <span class="spinner-circle-small white ms-2" v-if="loadingRelatedProducts[prod.id]" ></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconchecked from "@/assets/checked.png";
  import iconfav from "@/assets/fav-orange.svg";
  import iconclose from "@/assets/close.svg";
  import ProductImgDefault from "@/assets/images/product_default.png";
  import { Modal } from "bootstrap";
  import "vue3-carousel/carousel.css";
  import { Carousel, Slide, Navigation } from "vue3-carousel";
  import { useProductsStore, useProductStore } from "@/stores/productsStore";
  import { useCartStore } from "@/stores/cartStore";
  import { useRegisterStore } from "@/stores/register";

  export default {
    data() {
      return {
        product: null,
        selectedImage: "",
        iconchecked,
        iconfav,
        iconclose,
        ProductImgDefault,
        activeTab: "composition",
        modalInstance: null,
        qte: 1,
        related_products: [],
        productsStore: null,
        productStore: null,
        loadingAddProduct: false,
        loadingRelatedProducts: {},
        cartStore: useCartStore(),
        config: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        loading: true,
      };
    },
    components: {
      Carousel,
      Slide,
      Navigation,
    },
    props: {
      product_detail: {
        type: Object,
        required: true,
      },
      products: {
        type: Array,
        required: true,
      },
    },
    watch: {
      "$route.params.slug": function (newSlug, oldSlug) {
        if (newSlug !== oldSlug) {
          this.fetchProduct();
        }
      },
    },
    async created() {
      this.loading = true;
      if (this.product_detail && Object.keys(this.product_detail).length > 0) {
        this.product = { ...this.product_detail };
        this.selectedImage = this.product?.imagesDetails?.[0]?.path || this.ProductImgDefault;
        this.related_products = this.products
          .filter(product => product.variant?.inStock && product.id !== this.product?.id)
          .slice(-2);
      } else {
        await this.fetchProduct();
      }
      this.productsStore = useProductsStore();
      this.registerStore = useRegisterStore();
      this.loading = false;
    },
    mounted() {
      this.modalInstance = new Modal(this.$refs.modalRef);
      this.$nextTick(() => {
        if (this.product?.imagesDetails?.length > 1 && this.$refs.carousel) {
          this.$refs.carousel.slideTo(0);
          this.selectedImage = this.product.imagesDetails[0].path;
        }
      });
    },
    computed: {
      isClient() {
        return this.registerStore.user?.role === "client";
      },
    },
    methods: {
      selectImage(image) {
        this.selectedImage = image.path;
        const index = this.product?.imagesDetails?.findIndex(img => img.path === image.path);
        if (index !== -1 && this.$refs.carousel) {
          this.$refs.carousel.slideTo(index);
        }
      },
      onSlideChange({ currentSlide }) {
        if (this.product?.imagesDetails?.[currentSlide]) {
          this.selectedImage = this.product.imagesDetails[currentSlide].path;
        } else {
          this.selectedImage = this.ProductImgDefault;
        }
      },
      ChangeVariant(variant) {
        this.product = { ...this.product, variant };
        this.selectedImage = this.product?.imagesDetails?.[0]?.path || this.ProductImgDefault;
      },
      setActiveTab(tab) {
        this.activeTab = tab;
      },

      async AddProductToCart() {
        try {
          this.loadingAddProduct = true;
          const qte = this.qte;
          const code = this.product?.variant?.code;
          if (!code || !qte || qte <= 0) {
            this.loadingAddProduct = false;
            return;
          }
          await this.cartStore.addToCart(code, qte);
          this.modalInstance.show();
        } catch (error) {
          console.error("Error adding product to cart:", error);
        } finally {
          this.loadingAddProduct = false;
        }
      },
      CloseModalCart() {
        this.modalInstance.hide();
      },
      Increment() {
        this.qte += 1;
      },
      Decrement() {
        if (this.qte > 1) this.qte -= 1;
      },
      GoShopping() {
        this.modalInstance.hide();
        this.$router.push({ name: "supplyvet-products" });
      },
      FinishCheckout() {
        this.modalInstance.hide();
        this.$router.push({ name: "my-cart" });
      },
      async AddRelatedProductToCart(prod) {
        this.loadingRelatedProducts[prod.id] = true; // Set loading for specific product
        try {
          await this.cartStore.addToCart(prod.variant.code, 1);
          this.modalInstance.hide();
        } catch (error) {
          console.error("Error adding related product to cart:", error);
        } finally {
          this.loadingRelatedProducts[prod.id] = false; // Reset loading for specific product
        }
      },
      ToggleFavorite(prod) {
        if (!prod?.has_favorite) {
          this.product = { ...this.product, has_favorite: true };
          this.productsStore.AddFavoriteProduct(prod);
        } else {
          this.product = { ...this.product, has_favorite: false };
          this.productsStore.RemoveFavoriteProduct(prod);
        }
      },
      async fetchProduct() {
        this.loading = true;
        const slug = this.$route.params.slug;
        this.productStore = useProductStore();

        try {
          const product = await this.productStore.DetailProduct(slug);
          this.product = product;
          this.selectedImage = product?.imagesDetails?.[0]?.path || this.ProductImgDefault;
          this.related_products = this.products.filter(p => p.variant?.inStock && p.id !== product?.id).slice(-2);
        } catch (error) {
          console.error("Error fetching product:", error);
          this.product = {};
          this.selectedImage = this.ProductImgDefault;
        } finally {
          this.loading = false;
        }
      },
      generateTieredPrices() {
        const baseUnitPrice = this.isClient
          ? this.product?.variant?.price_ttc || 0
          : this.product?.variant?.price_ht || 0;
        const ref = this.product?.variant?.name;

        if (!ref || !baseUnitPrice) return [];

        const variantsSameRefWithUnity =
          this.product?.variantsDetails
            ?.filter(v => v.ref === ref && v.unity && /^(\d+)u$/.test(v.unity))
            .map(v => ({
              unity: parseInt(v.unity),
              price: this.isClient ? v.price_ttc || 0 : v.price_ht || 0,
            }))
            .sort((a, b) => a.unity - b.unity) || [];

        const tiers = [];

        if (variantsSameRefWithUnity.length === 0) {
          tiers.push({
            label: `1 unité`,
            price: this.formatPrice(baseUnitPrice),
          });
          return tiers;
        }

        const minUnity = variantsSameRefWithUnity[0].unity;

        if (minUnity > 1) {
          tiers.push({
            label: "1 unité",
            price: this.formatPrice(baseUnitPrice),
          });
        }

        variantsSameRefWithUnity.forEach(v => {
          tiers.push({
            label: `${v.unity} unités`,
            price: this.formatPrice(v.price),
          });
        });

        return tiers;
      },
      formatPrice(value) {
        if (value == null) return "0,00";
        const num = Number(value) / 100;
        return num.toFixed(2).replace(".", ",");
      },
      getConstituantsAnalytiques() {
        const result = {
          label: "",
          rows: [],
        };

        if (!this.product?.analyticalConstituents) return result;

        let lines = this.product.analyticalConstituents
          .split(/<br\s*\/?>/i)
          .map(line => line.trim())
          .filter(line => line);

        if (lines.length > 0) {
          const labelMatch = lines[0].match(/^(.*?:)/);
          if (labelMatch) {
            result.label = labelMatch[1].trim();
            lines[0] = lines[0].substring(labelMatch[1].length).trim();
            if (!lines[0]) lines.shift();
          }
        }

        // Si aucune ligne avec "|"
        if (!lines.some(line => line.includes("|"))) {
          lines.forEach(line => {
            if (line) result.rows.push({ name: line, value: "" });
          });
        } else {
          lines = lines.filter(line => line.includes("|")).map(line => line.replace(/\[|\]/g, "").trim());
          lines.forEach(line => {
            const [name, value] = line.split("|").map(part => part.trim());
            if (name) result.rows.push({ name, value: value || "" });
          });
        }

        return result;
      },
      transformSectionTitles(html) {
        if (!html) return "";
        const regex = /(^|<[pdiv][^>]*>)\s*([^<]+?:)\s*(?=(<br\s*\/?>|\s|$))/gim;
        let transformedHtml = html.replace(regex, (match, openingTag, title) => {
          return `${openingTag || ""}<b>${title}</b><br>`;
        });
        return this.$sanitize.sanitizeProductInfo(transformedHtml);
      },
      hasIngredientsTitle(html) {
        if (!html) return false;
        const text = html
          .replace(/<[^>]*>/g, "")
          .trim()
          .toLowerCase();
        return text.startsWith("ingrédients spécifiques") || text.startsWith("ingredients specifiques");
      },
      getAdditivesData() {
        const structuredResult = {
          type: "structured",
          label: "",
          sections: [],
        };

        const simpleResult = {
          type: "simple",
          label: "",
          content: "",
        };

        if (!this.product?.additives) return structuredResult;

        let lines = this.product.additives
          .split(/<br\s*\/?>/i)
          .map(line => line.trim())
          .filter(line => line);

        const hasStructuredRows = lines.some(line => line.includes("[") && line.includes("]"));

        if (hasStructuredRows) {
          if (lines.length > 0) {
            const mainLabelMatch = lines[0].match(/^(.*?:)/);
            if (mainLabelMatch) {
              structuredResult.label = mainLabelMatch[1].trim();
              lines[0] = lines[0].substring(mainLabelMatch[1].length).trim();
              if (!lines[0]) {
                lines.shift();
              }
            }
          }

          let currentSection = { label: "", rows: [] };

          lines.forEach(line => {
            const sectionLabelMatch = line.match(/^(.*?:)$/);
            if (sectionLabelMatch) {
              if (currentSection.label || currentSection.rows.length > 0) {
                structuredResult.sections.push(currentSection);
              }
              currentSection = { label: sectionLabelMatch[1].trim(), rows: [] };
            } else if (line.includes("[") && line.includes("]")) {
              const cleanedLine = line.replace(/\[|\]/g, "").replace(/\.$/, "").trim();
              const [name, value = ""] = cleanedLine.split("|").map(part => part.trim());
              if (name) currentSection.rows.push({ name, value });
            } else if (line) {
              currentSection.rows.push({ name: line, value: "" });
            }
          });

          if (currentSection.label || currentSection.rows.length > 0) {
            structuredResult.sections.push(currentSection);
          }

          return structuredResult;
        } else {
          if (lines.length > 0) {
            const firstColonIndex = lines[0].indexOf(":");
            if (firstColonIndex !== -1) {
              simpleResult.label = lines[0].substring(0, firstColonIndex + 1).trim();
              let restOfFirstLine = lines[0].substring(firstColonIndex + 1).trim();
              lines.shift();
              if (restOfFirstLine) lines.unshift(restOfFirstLine);
            } else if (lines[0].endsWith(":")) {
              simpleResult.label = lines[0];
              lines.shift();
            }
          }

          simpleResult.content = lines.join("<br />") || "Aucun additif disponible.";
          return simpleResult;
        }
      },
    },
  };
</script>
<style scoped>
  .product-card {
    text-align: left;

    .prod-image {
      padding: 15px;
      border: 1px solid #ddd;
      border-radius: 10px;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
      background: #fff;
    }
  }

  .product-card img {
    max-width: 100%;
    height: auto;
  }

  .cursor-pointer {
    cursor: pointer;
  }
  .thumbnail {
    margin-right: 4px;
    cursor: pointer;
  }

  .product-info {
    padding: 5px;

    .gamme {
      display: block;
      font-size: 20px;
      font-weight: 300;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }

    .title {
      display: block;
      font-size: 23px;
      font-weight: bold;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }

    .reference {
      font-size: 13px;
      color: #666666;
    }

    .desc {
      text-align: left;

      label {
        font-size: 16px;
      }
    }
  }

  .price-unites {
    color: grey;
    background-color: #fff;
    border-radius: 8px;
    padding: 8px;
    font-size: 17px;
    width: max-content;
    display: grid;
    margin: 7px;
  }

  .price {
    font-weight: bold;
    font-size: 27px !important;
    color: #1e347d;
  }

  .old-price {
    font-weight: bold;
    color: gray;
  }

  .old-price label {
    font-size: 27px !important;
  }

  .old-price span,
  .old-price label {
    text-decoration: line-through;
  }

  .round {
    border: 1px solid #1e347d;
    border-radius: 76px;
    color: #1e347d;
    cursor: pointer;
  }

  .round.active {
    background: #1e347d;
    color: white;
  }

  .discount {
    border: 1px solid #ec621a;
    border-radius: 76px;
    color: #ec621a;
    float: right;
    font-weight: bold;
  }

  .check-disponibility {
    font-style: italic;

    label {
      color: green;
      margin-right: 8px;
    }

    label::before {
      content: "";
      display: inline-block;
      width: 13px;
      height: 13px;
      background-color: green;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #666666;
    }
  }

  .block-btn-cart {
    height: 35px;
  }

  .block-btn-cart img {
    height: 100%;
  }

  .input-wrapper {
    display: contents;
  }

  .btn-minus,
  .btn-plus {
    width: 4%;
    color: #fff;
    text-align: center;
    cursor: pointer;
    -moz-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
  }

  .btn-minus {
    background-color: #ec621a;
    opacity: 0.5;
  }

  .btn-plus {
    background-color: #ec621a;
  }

  .number-input {
    width: 5%;
    border: 1px solid rgba(236, 98, 26, 0.4);
    text-align: center;
    font-size: 18px;
    color: #ec621a;
  }

  .input-wrapper input {
    border-radius: 0;
  }

  .input-wrapper .btn-minus {
    border-radius: 30px 0 0 30px;
    font-size: 25px;
  }

  .input-wrapper .btn-plus {
    border-radius: 0 30px 30px 0;
    font-size: 25px;
  }

  .pre-commande,
  .add-cart {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .add-cart {
    margin-left: 1rem;
  }

  .favorite-wrapper {
    color: #ec621a;
    cursor: pointer;

    span {
      font-size: 12px;
      font-weight: bold;
    }
  }

  @media (min-width: 768px) and (max-width: 1367px) {
    .product-card {
      .title {
        font-size: 14px;
      }

      .desc {
        label {
          font-size: 12px;
        }
      }
    }

    .price {
      font-weight: 600;
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    .product-card {
      .title {
        font-size: 13px;
      }

      .desc {
        label {
          font-size: 12px;
        }
      }
    }

    .price {
      font-weight: 600;
      font-size: 12px;
    }

    /* Ajustements pour les boutons sur petits écrans */
    .block-btn-cart {
      height: auto;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
    }

    .btn-minus,
    .btn-plus {
      width: 35px;
      min-width: 35px;
      height: 35px;
      font-size: 20px !important;
    }

    .number-input {
      width: 45px;
      min-width: 45px;
      font-size: 16px;
    }

    .add-cart {
      font-size: 16px;
      padding: 8px 16px;
      margin-left: 0.5rem;
      white-space: nowrap;
    }

    .favorite-wrapper {
      display: flex;
      align-items: center;
      height: 25px;
      border: 1px solid;
      border-radius: 20px;
      padding: 0 10px;
      margin: 10px;

      img {
        height: 20px;
      }

      span {
        font-size: 9px;
      }
    }
  }

  /* Ajustements supplémentaires pour très petits écrans */
  @media (max-width: 576px) {
    .block-btn-cart {
      gap: 6px;
    }

    .btn-minus,
    .btn-plus {
      font-size: 18px !important;
    }

    .number-input {
      width: 40px;
      min-width: 40px;
      font-size: 14px;
    }

    .add-cart {
      font-size: 16px;
    }
  }

  .carousel {
    --vc-nav-background: rgba(255, 255, 255, 0.7);
    --vc-nav-border-radius: 100%;
  }

  .carousel__wrapper {
    padding: 2px;
    position: relative;
    margin: 0 auto;
  }

  :deep(.carousel__icon) {
    fill: #1e347d;
    height: 70%;
  }

  :deep(.carousel__next),
  :deep(.carousel__prev) {
    border: 1px solid #1e347d !important;
    background: #eff1f7;
  }

  :deep(.carousel__next:hover),
  :deep(.carousel__prev:hover) {
    background: #c9cfde;
  }

  .tab-container {
    width: 100%;
    /* max-width: 1350px; */
    background: white;
    border-radius: 0 10px 10px 10px;
    overflow: hidden;
  }

  .tabs {
    display: flex;
    gap: 0px;
  }

  .tab {
    padding: 10px 20px;
    font-weight: bold;
    cursor: pointer;
    color: #ec621a;
    background-color: #fafafa;
  }

  .tab.active {
    background: white;
    color: #1e347d;
  }

  .tab-content-container {
    width: 100%;
    padding: 20px;
    background: #fff;
  }

  .tab-content {
    width: 100%;
    max-width: 1200px;
    font-size: 16px;
    line-height: 1.6;
  }

  .cart-product-card {
    text-align: left;

    .cart-product-image {
      border-radius: 10px;
      background: #fff;
    }
  }

  .cart-product-card img {
    max-width: 100%;
    height: auto;
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .cart-product-info {
    padding: 5px;

    .gamme {
      display: block;
      font-size: 20px;
      font-weight: 300;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }

    .title {
      display: block;
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }

    .reference {
      font-size: 13px;
      color: #666666;
    }

    .desc {
      text-align: left;

      label {
        font-size: 16px;
      }
    }

    .price span {
      font-size: 18px;
    }
  }

  .btn-checkout {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .btn-shopping {
    border-color: #ec621a !important;
    color: #ec621a !important;
    border-radius: 76px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .btn-qt {
    color: #1e347d;
    border-color: gray !important;
    border-radius: 76px;
    text-align: center;
  }

  .title-blue {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .related-products .info .title {
    color: #1e347d;
    font-size: 15px;
    font-weight: bold;
  }

  .related-product-card {
    text-align: left;

    .related-product-image {
      border-radius: 10px;
      background: #fff;
      height: 170px;
    }
  }

  .related-product-card img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .related-product-info {
    padding: 5px;

    .title {
      display: block;
      font-size: 15px;
      font-weight: bold;
      font-style: normal;
      color: #1e347d;
      min-height: 45px;
    }

    .sub-title {
      font-size: 17px;
    }

    .price {
      font-size: 22px !important;
    }

    .price span {
      font-size: 15px;
    }
  }

  .prod-caract {
    border: 1px solid #1e347d;
    border-radius: 76px;
    color: #1e347d;
  }

  .btn-add-cart {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .constituants-section {
    border: none !important;
  }

  .constituants-table th,
  .constituants-table td,
  .constituants-table thead,
  .constituants-table tbody,
  .constituants-table tr {
    border: none !important;
    border-top: none !important;
    border-bottom: none !important;
  }

  .constituants-table thead th {
    border-bottom: none !important;
  }

  .section-title-blue,
  :deep(b) {
    color: #1e347d !important;
    text-transform: uppercase;
  }

  .ingredients-content :deep(b),
  .ingredients-content :deep(strong) {
    color: inherit;
    text-transform: none;
  }

  .first-tab {
    border-radius: 10px 10px 0 0;
  }

  .second-tab {
    border-radius: 10px 10px 0 0;
  }

  .constituants-table tbody td:nth-child(2),
  .additives-table tbody td:nth-child(2) {
    text-align: end;
  }

  .spinner-circle-small {
    display: inline-block;
    width: 17px;
    height: 17px;
    border: 2px solid #ccc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .spinner-circle-small.orange {
    border-color: #ec621a;
    border-top-color: transparent;
  }

  .spinner-circle-small.white {
    border-color: white;
    border-top-color: transparent;
  }
</style>
